import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import { firestore } from '../firebase/firebase';

const styles = theme => ({
  root: {
    width: '90%',
    margin: '0 auto',
    marginTop: '30px',
    maxHeight: '100%'
  },
  head: {
    background: 'linear-gradient(60deg, #26da76, #227b37)'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    color: 'white'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20
  },
  details: {
    alignItems: 'center'
  },
  column: {
    // flexBasis: "33.33%",
    width: '100%'
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  shadowed: {
    boxShadow: '0 4px 20px 0px rgba(0, 0, 0, 0.14)',
    boxShadow: '0 7px 10px -5px rgb(63, 126, 23)'
  }
});

class DetailedExpansionPanel extends React.Component {
  constructor(props) {
    super(props);
    const { classes, parentState } = this.props;
    this.state = {
      service: {
        fullText: '',
        parsed: ''
      },
      expansionPanelOpen: false
    };
  }

  componentDidMount() {
    // console.log(this.props.parentState);
    firestore
      .collection('active')
      .doc(this.props.parentState.selectedNumber)
      .onSnapshot(snapshot => {
        if (
          snapshot.data()[this.props.parentState.selected] &&
          snapshot.data()[this.props.parentState.selected].fullText
        ) {
          this.setState({
            service: snapshot.data()[this.props.parentState.selected],
            expansionPanelOpen: true
          });
          // console.log(snapshot.data()[this.props.selected]);
        } else {
          // this.setState({
          //   service: snapshot.data()[this.props.parentState.selected]
          // });
        }

        // console.log(this.state.service);
      });
  }

  render() {
    return (
      <div className={this.props.classes.root}>
        {/* {console.log("PANEL2 PROPS/n", this.props)} */}
        <ExpansionPanel
          expanded={!!this.state.expansionPanelOpen}
          disabled={!this.state.service.fullText}
          // disabled={false}
          className={this.props.classes.shadowed}
        >
          <ExpansionPanelSummary
            expandIcon={
              <ExpandMoreIcon
                style={{ color: '#eee' }}
                onClick={() => {
                  if (this.state.service.fullText) {
                    this.setState({
                      expansionPanelOpen: !this.state.expansionPanelOpen
                    });
                  }
                  // this.state.service.fullText
                  //   ? this.setState({
                  //       expansionPanelOpen: !this.state.expansionPanelOpen
                  //     })
                  //   : null;
                }}
              />
            }
            className={this.props.classes.head}
          >
            <div className={this.props.classes.column}>
              <Typography className={this.props.classes.heading}>
                Confirmation Code
              </Typography>
            </div>
            <div className={this.props.classes.column}>
              {/* <Typography className={classes.secondaryHeading}>Select trip destination</Typography> */}
            </div>
          </ExpansionPanelSummary>
          <Divider />
          <ExpansionPanelDetails className={this.props.classes.details}>
            <div className={this.props.classes.column}>
              <FormControl className={this.props.classes.formControl}>
                <InputLabel htmlFor="name-simple">
                  Parsed code from SMS
                </InputLabel>
                <Input id="name-simple" value={this.state.service.parsed} />
              </FormControl>
              <TextField
                id="multiline-flexible"
                label="Full Text"
                multiline
                //   rowsMax="4"
                //   value={props.parentState.fullText}
                // value={props.parentState.fullText}
                //   onChange={this.handleChange("multiline")}
                className={this.props.classes.textField}
                margin="normal"
                fullWidth
                value={this.state.service.fullText}
              />
            </div>
          </ExpansionPanelDetails>
          <Divider />
          {/* <ExpansionPanelActions>
            <Button size="small">Cancel</Button>
            <Button size="small" color="primary">
              Save
            </Button>
          </ExpansionPanelActions> */}
        </ExpansionPanel>
      </div>
    );
  }
}

DetailedExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DetailedExpansionPanel);
